<template>
  <div class="body evel-II">
    <zdylayout>
      <template v-slot:query-box-filed>
        <el-form
          ref="form"
          :model="form"
          label-width="80px"
          @submit.native.prevent
          class="operationControl"
          :inline="true"
          label-suffix=":"
          size="small"
        >
          <el-form-item label="课程名称" prop="trainingName">
            <el-input
              v-model="form.trainingName"
              @keyup.enter.native="search"
              clearable
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="培训类型" prop="trainingCategoryName">
            <el-input
              clearable
              @focus="showSelectTreeCategoryVisible"
              ref="trainingCategoryInput"
              @clear="trainingCategoryNameClear"
              :disabled="$route.query.type == 'check'"
              v-model="form.trainingCategoryName"
            >
            </el-input>
          </el-form-item> -->
          <!--          <el-col :span="6" class="pr20">-->
          <!--            <el-form-item label="状态" prop="isShelf">-->
          <!--              <el-select v-model="form.isShelf" clearable placeholder="状态">-->
          <!--                <el-option :key="true" label="上架" :value="true"></el-option>-->
          <!--                <el-option :key="false" label="下架" :value="false"></el-option>-->
          <!--              </el-select>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <el-form-item label="课程目录" prop="directoryId">
            <selectTree
              :props="{
                value: 'id', // ID字段名
                label: 'directoryName', // 显示名称
                children: 'directoryList' // 子级字段名
              }"
              :options="catalogList"
              :value="form.directoryId"
              :disabled="$route.query.type == 'check'"
              @getValue="selectTreeChange"
              clearable
            ></selectTree>
          </el-form-item>
          <div class="fa-pull-right">
            <el-form-item>
              <el-button type="primary" @click="search">搜索</el-button>
              <el-button @click="resetForm('form')">重置</el-button>
            </el-form-item>
          </div>
        </el-form>
      </template>
      <template v-slot:query-box-button> </template>
      <template v-slot:layer-body-front>
        <div class="fl">
          <!-- todocc 批量删除 -->
          <!-- <el-button
            @click="delByIds"
            type="danger"
          >
            批量删除
          </el-button> -->
          &nbsp;&nbsp;
          <el-button
          @click="$router.push('/examination/directory?type=edit')"
          >
            目录管理
          </el-button>
        </div>
        <div class="fa-pull-right">
          <el-button
            @click="$router.push('/examination/course/addCourse?type=edit')"
            type="primary"
            icon="el-icon-plus"
            class="mb20"
            >新增
          </el-button>
        </div>
      </template>
      <template v-slot:body-table>
        <el-table
          class="common_tables"
          :data="programList"
          style="width: 100%"
          @filter-change="handleFilter"
          v-loading="tableLoading"
          element-loading-text="拼命加载中"
        >
          <el-table-column
            type="index"
            width="60"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="trainingName"
            label="课程名称"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <!-- prop="isMallImport"-->
          <!-- <el-table-column width="100">
            <template slot="header" slot-scope="scope">
              <span>来源</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <div
                  slot="content"
                  v-html="courseUtils.sourceTooltipExplain()"
                ></div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>

            <template slot-scope="scope">
              <span v-html="courseUtils.translateSourceName(scope.row)"></span> -->
              <!-- 0未下达 1进行中 2已下达 -->
              <!--            <span v-if="scope.row.isMallImport != 1 && scope.row.sourceId">平台分配</span>-->
              <!--            <span v-if="scope.row.isMallImport!=1 && !scope.row.sourceId">企业制作</span>-->
              <!--            <span v-if="scope.row.isMallImport == 1">商城</span>-->
            <!-- </template>
          </el-table-column> -->
          <!-- <el-table-column
            label="培训类型"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.trainingLevelName"
                v-html="scope.row.trainingLevelName"
              >
              </span>
              <span v-else>
                --
              </span>
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            label="行业类型"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.trainingIndustryName"
                v-html="scope.row.trainingIndustryName"
              >
              </span>
              <span v-else>
                --
              </span>
            </template>
          </el-table-column> -->
          <el-table-column
            width="150"
            prop="createdTime"
            label="创建时间"
          ></el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                @click="
                  $router.push(
                    '/examination/course/detailCourse?type=check&id=' +
                      scope.row.id
                  )
                "
                >详情
              </el-button>
              <el-button
                size="mini"
                type="primary"
                v-if="scope.row.isMallImport !== 1"
                @click="
                  $router.push(
                    '/examination/course/updateCourse?type=edit&id=' +
                      scope.row.id
                  )
                "
                >编辑
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="delProgram(scope.row.id, scope.row.isMallImport)"
                >删除
              </el-button>
              <!--            <el-button size="mini" type="text" v-if="isOperating()" @click="showImportDrawer(scope.row.id)">导入-->
              <!--            </el-button>-->
              <!--            <el-button size="mini" type="text" v-if="!scope.row.shelf && isOperating()"-->
              <!--              @click="changeShelf(scope.row,  true)">上架-->
              <!--            </el-button>-->
              <!--            <el-button size="mini" type="text" v-if="scope.row.shelf && isOperating()"-->
              <!--              @click="changeShelf(scope.row,  false)">下架-->
              <!--            </el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:body-pagination>
        <div class="common_btm_pagination">
          <el-pagination
            background
            @size-change="sizeChange"
            :current-page="page"
            @current-change="pageChange"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </template>
    </zdylayout>

    <selectTrainingCategory
      ref="selectTrainingCategory"
      @submit="selectTrainingCategorySubmitHandle"
    ></selectTrainingCategory>

    <courseImport ref="courseImport"></courseImport>
  </div>
</template>

<script>
import API from "../../../api/new/training.js";
import api from "../../../api/new/training";
import exam from "@/api/new/exam.js";
import courseImport from "@/pages/trainingManagement/course/courseImport";
import selectTree from "@/components/common/selectTree";
import selectTrainingCategory from "@/components/training/selectTrainingCategory";
import config from "@/config/config.js";
import courseUtils from "@/common/courseUtils.js";

export default {
  components: { selectTree, selectTrainingCategory, courseImport },
  data() {
    return {
      config: config,
      courseUtils: courseUtils,
      selectTreeCategoryVisible: false,
      form: {
        trainingName: undefined, //培训内容
        principalName: undefined, //负责人名称
        trainingContent: undefined, //培训内容
        startCreatedTime: undefined, //制定开始时间
        endCreatedTime: undefined, //制定结束时间
        issuedStatus: undefined, //下发状态
        startIssuedTime: undefined, //下发开始时间
        endIssuedTime: undefined, //下发结束时间
        createdTime: [],
        issuedTime: [],
        shelf: undefined, //上下架状态
        directoryId: undefined,

        // training
        trainingLevelName: undefined,
        trainingIndustryName: undefined,
        trainingPostName: undefined,
        trainingTypeName: undefined,

        trainingCategoryName: undefined
      },
      programList: [],
      page: 1,
      pageSize: 10,
      total: 0 // 总条数
    };
  },
  mounted() {
    this.search();
    this.getCatalogList();
  },
  methods: {
    sizeChange(e) {
      this.pageSize = e;
      this.getProgramList();
    },
    pageChange(e) {
      this.page = e;
      this.getProgramList();
    },
    trainingCategoryNameClear() {
      this.form.trainingLevelName = undefined;
      this.form.trainingIndustryName = undefined;
      this.form.trainingPostName = undefined;
      this.form.trainingTypeName = undefined;
    },
    search() {
      this.page = 1;
      this.getProgramList();
    },
    getProgramList() {
      let p = {
        ...this.form,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };
      p.page = this.page;
      p.pageSize = this.pageSize;

      delete p.trainingCategoryName;

      if (p.createdTime.length > 0) {
        p.startCreatedTime = p.createdTime[0];
        p.endCreatedTime = p.createdTime[1];
      }

      if (p.issuedTime.length > 0) {
        p.startIssuedTime = p.issuedTime[0];
        p.endIssuedTime = p.issuedTime[1];
      }
      delete p.createdTime;
      delete p.issuedTime;

      this.tableLoading = true;
      //getProgramList
      //getPageResourcesList

      API.getPageProgramList(p).then(res => {
        this.programList = res.data.records;
        console.log(this.programList);
        this.total = res.data.total;
        this.tableLoading = false;
      });
    },
    handleFilter(value) {
      if (value.shelf && value.shelf.length == 1) {
        this.form.isShelf = value.shelf[0];
      } else {
        this.form.isShelf = undefined;
      }
      this.search();
    },
    selectTrainingCategorySubmitHandle(data) {
      this.form.trainingLevelName = data.trainingLevelName;
      this.form.trainingIndustryName = data.trainingIndustryName;
      this.form.trainingPostName = data.trainingPostName;
      this.form.trainingTypeName = data.trainingTypeName;
      this.form.trainingCategoryName = data.trainingCategoryName;
    },
    showSelectTreeCategoryVisible() {
      this.$refs.trainingCategoryInput.blur();
      this.$refs.selectTrainingCategory.showDialog();
    },
    onSubmit() {
      console.log("submit!");
    },
    handleClick(row) {
      console.log(row);
    },
    //重置表单
    resetForm(formName) {
      this.trainingCategoryNameClear();
      this.$refs[formName].resetFields();
      this.search();
    },
    delProgram(programId, type) {
      var enterpriseId = JSON.parse(localStorage.getItem("userinfo"))
        .enterpriseId;

      this.$confirm("此操作将删除该计划, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        API.remove({ programId })
          .then(res => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.getProgramList();
            } else {
              this.$message({
                type: "error",
                message: res.message
              });
            }
          })
          .catch(error => {
            this.$message({
              type: "error",
              message: "课程已绑定培训，无法删除"
            });
            // console.log("---------")
            // console.log(error.status)
            // console.log(error)
          });

        // API.delProgram({programId,
        //   type,
        //   enterpriseId}).then(res => {
        //   if (res.code == 0) {
        //     this.$message({
        //       type: "success",
        //       message: "删除成功!"
        //     });
        //     this.getProgramList();
        //   } else {
        //     this.$message({
        //       type: "error",
        //       message: res.message
        //     });
        //   }
        // });
      });
    },
    showImportDrawer(trainingProgramId) {
      this.$refs.courseImport.showImportDrawer(trainingProgramId);
    },
    /**
     * 变更上下架状态
     * @param row
     * @param isShelf
     */
    changeShelf(row, isShelf) {
      let params = {
        id: row.id,
        isShelf: isShelf
      };
      api.changeShelf(params).then(res => {
        if (res.code == 0) {
          if (isShelf) {
            this.$message.success("已上架");
          } else {
            this.$message.success("已下架");
          }
          this.getProgramList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getCatalogList() {
      exam
        .getCatalogList({
          type: 4,
          enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
            .enterpriseId
        })
        .then(res => {
          this.catalogList = res.data;
        });
    },
    selectTreeChange(v) {
      this.form.directoryId = v.id;
    },
    /**
     * 判断是否是运营人员
     */
    isOperating() {
      let userInfo = JSON.parse(localStorage.getItem("userinfo"));
      return userInfo.isOperating;
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  position: relative;
}

.searchBut {
  position: absolute;
  right: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/course/courseManagement.vue